import IconCatch from '@/components/icons/icon-catch/icon-catch';
import HeaderBackground from '@/components/ui/header-background/header-background';
import { ROUTE_ACCOUNT } from '@/constants/routes';
import { Box, Divider, Flex, IconChevronRight, IconLogout, Link, Text } from '@cmpsr/components';
import { Fragment } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { DashboardNavigationBarProps } from '../../types';
import MobileNavigationMenuHeader from './mobile-navigation-menu-header';

type MobileNavigationMenuProps = DashboardNavigationBarProps & {
  onClose: () => void;
};

export default function MobileNavigationMenu({
  onClose,
  handleLogout,
  menuItems,
  name,
  email,
  children,
}: MobileNavigationMenuProps) {
  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      flexDirection="column"
      overflow="hidden"
      px={{ base: 'spacer-5', md: 'spacer-8' }}
    >
      <HeaderBackground blur={30} />
      <Flex position="relative" zIndex={1} flexDirection="column" height="100%">
        <MobileNavigationMenuHeader onClose={onClose} />
        <Flex
          as={ReactRouterLink}
          to={ROUTE_ACCOUNT}
          justifyContent="space-between"
          alignItems="center"
          gap="spacer-4"
          pb="spacer-6"
          aria-label="Navigates to Account"
        >
          <IconCatch
            icon="Profile-User"
            flexShrink={0}
            height="40px"
            width="40px"
            backgroundColor="lightBlue"
            p={2}
            borderRadius="50%"
            overflow="hidden"
            alt="User icon"
          />
          <Box w="100%" overflow="hidden">
            <Text variant="text-body-medium" color="text-light" noOfLines={1}>
              {name}
            </Text>
            <Text variant="text-body-meta-regular" color="text-secondary-negative" noOfLines={1}>
              {email}
            </Text>
          </Box>
          <IconChevronRight color="text-light" />
        </Flex>
        {children}
        <Flex flexDirection="column" gap="spacer-5" mb="spacer-14">
          {menuItems.map((menuItem) => (
            <Fragment key={menuItem.item}>
              <Divider h="1px" background="gradient-02" borderBottom="unset" />
              <Link variant="link-light" size="l" as={ReactRouterLink} to={menuItem.href}>
                {menuItem.label}
              </Link>
            </Fragment>
          ))}
          <Divider h="1px" background="gradient-02" borderBottom="unset" />
        </Flex>
        <Link
          role="button"
          aria-label="Log out"
          onClick={handleLogout}
          variant="link-light"
          leadingIcon={<IconLogout color="text-light" />}
        >
          Log out
        </Link>
      </Flex>
    </Flex>
  );
}
